<template>
    <!-- `boxed` wraps the state in a flat bordered card so it reads as contained content
         rather than floating in an open section — the convention set by ProjectsList. -->
    <component
        :is="boxed ? 'v-base-card' : 'div'"
        v-bind="boxed ? { size: 'lg' } : {}"
    >
        <div :class="['text-center', boxed ? 'py-6' : '']">
            <v-icon
                class="mx-auto text-gray-600"
                :size="iconSize"
                :type="icon"
                weight="light"
            />
            <p :class="['mt-2 font-semibold text-v-dark-950', titleClass]">
                {{ title }}
            </p>
            <p :class="['mt-1 text-v-dark-400', descriptionClass]">
                <slot name="description">
                    {{ description }}
                </slot>
            </p>
            <div
                v-if="$slots.actions"
                class="mt-6 flex items-center justify-center gap-3"
            >
                <slot name="actions" />
            </div>
            <!-- A muted note under the actions (e.g. an icon and one line of reassurance). -->
            <div
                v-if="$slots.footer"
                class="mt-5 flex items-center justify-center gap-1.5 text-xs text-v-dark-400"
            >
                <slot name="footer" />
            </div>
        </div>
    </component>
</template>

<script>
    import VBaseCard from '@/components/elements/VBaseCard.vue';
    import VIcon from '@/components/elements/VIcon';

    const SIZE_TOKENS = {
        sm: { icon: '8', title: 'text-sm', description: 'text-xs' },
        md: { icon: '12', title: 'text-base', description: 'text-sm' },
        lg: { icon: '16', title: 'text-lg', description: 'text-base' },
    };

    export default {
        components: {
            VBaseCard,
            VIcon,
        },
        props: {
            // Wrap the empty state in a flat bordered VBaseCard (contained look).
            boxed: {
                default: false,
                type: Boolean,
            },
            description: {
                default: '',
                type: String,
            },
            icon: {
                default: 'x-circle',
                type: String,
            },
            title: {
                required: true,
                type: String,
            },
            size: {
                default: 'md',
                type: String,
                validator: v => Object.keys(SIZE_TOKENS).includes(v),
            },
        },
        computed: {
            sizeTokens() {
                return SIZE_TOKENS[this.size];
            },
            iconSize() {
                return this.sizeTokens.icon;
            },
            titleClass() {
                return this.sizeTokens.title;
            },
            descriptionClass() {
                return this.sizeTokens.description;
            },
        },
    };
</script>